/**
 * 旅游景点模块，异步加载
 * @author yongsheng.zhang
 * @Date 2017.7.28
 */
const $ = require('jquery');
const doT = require('dot');
const Domain = location.href.indexOf('51ping') !== -1 ? '//st.lvyou.meituan.com' : '//itrip.meituan.com';
const sceneTpl = require('../../../tpl/travel-scene-cata.html.js');
const LazyLoad = require('../../../lib/lazyload.js')
const Rohr = require('../../../lib/rohr.js')
const Cookie = require('../../../lib/cookie.js');
const LXBid = require('../../../lib/lx-bid.js')
const LXWrap = require('../../../lib/lx.js')

let templateSceneInfo = doT.template(sceneTpl);
let param = {
    cityId: window._DP_HeaderData && window._DP_HeaderData.cityId ? window._DP_HeaderData.cityId : 1,
    sceneInfo: {}
}
let uuid = Cookie.readCookie('_lxsdk_cuid') || '' // 反爬虫用
let timeing = window.performance ? window.performance.timing.navigationStart : _start

/**
 * 获取景点信息
 * @param {*} any
 */
const sceneInit = () => {
    let $scene = $('#travel-scene-cata');
    let $cataNav = $('#cata-nav');
    // 增加反爬虫人机识别
    let ajaxUrlToken
    try {
        ajaxUrlToken = Rohr(`${Domain}/mdr/api/v1/rank/module/detail`, {
            cityId: param.cityId,
            selectedCityId: param.cityId,
            rankId: 'publicPraise',
            needTabInfo: 0,
            uuid: uuid,
            platform: 1,
            partner: 150,
            limit: 6,
            originUrl: location.href
        })
    } catch (e) {
        console.log('rohr error')
    }
    $.ajax({
        url: `${Domain}/mdr/api/v1/rank/module/detail`,
        type: 'GET',
        dataType: 'json',
        data: {
            cityId: param.cityId,
            selectedCityId: param.cityId,
            rankId: 'publicPraise',
            needTabInfo: 0,
            uuid: uuid,
            platform: 1,
            partner: 150,
            originUrl: location.href,
            limit: 6,
            _token: ajaxUrlToken
        }
    })
        .then(result => {
            if (result && result.status === 0 && result.data && result.data.shopList) {
                param.sceneInfo = result.data.shopList;
                let sceneLength = 0;
                param.sceneInfo.forEach(function(item, index) {
                    if (item.imageUrl.indexOf('w.h') !== -1) {
                        item.imageUrl = item.imageUrl.replace('w.h', '370.208');
                    }
                    sceneLength = sceneLength + 1
                    return item;
                });
                let sceneInfoHtml = $(templateSceneInfo(param));
                $scene.find('.scene-list').append(sceneInfoHtml);
                if (result.data.shopList.length < 3) {
                    $scene.remove();
                    $('#cata-nav').find('.travel-scene-cata-nav').remove();
                }
                LXWrap($('.travel-scene-cata .shop-item-pic'), LXBid.poiClickBid, true, false)
                LXWrap($('.travel-scene-cata .shop-name'), LXBid.poiClickBid, true, false)
                var _lazyload = new LazyLoad({
                    item : $('#travel-scene-cata img'), // 需要被懒加载的图片
                    attr : 'lazy-src'
                });
                console.log('sceneInfo success');
            } else {
                $scene.remove();
                $cataNav.find('.travel-nav-detail').remove();
            }
            try {
                Owl.addPoint({
                    position: 3,
                    duration: +new Date() - timeing
                })   
                Owl.sendPoints();
            } catch (e) {
                console.log('owl addpoint 3 scene error');
            }
        }, error => {
            if (error) {
                $scene.remove();
                $cataNav.find('.travel-nav-detail').remove();
                console.log('sceneInfo fail');
            }
        });
}

module.exports = sceneInit



// WEBPACK FOOTER //
// ./src/pages/index/component/scene.js